import services from 'api/services';
import {
  GET_ALL_EXERCISES_REQUEST,
  GET_ALL_EXERCISES_SUCCESS,
  GET_ALL_EXERCISES_FAILURE,
  SET_FILTERS,
} from './constants';
import { logError } from 'global/errors';

const { ChallengeService } = services;

export const getAllExercises = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_EXERCISES_REQUEST });
    const exercises = await ChallengeService.getAllItems('exercises');
    dispatch({
      type: GET_ALL_EXERCISES_SUCCESS,
      exercises: exercises.map((item) => {
        item.thumbnail = item.backgroundImage?.thumbnail || item.backgroundImage?.url;
        item.keywords = item.tags || [];
        item.html = item.landingPageContent;
        delete item.backgroundImage;
        delete item.tags;
        return item;
      }),
    });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_ALL_EXERCISES_FAILURE, error: ex.message });
  }
};

export const setTagFilters = (filters) => async (dispatch) => {
  dispatch({ type: SET_FILTERS, filters });
};
